import React from "react";

import {
    ComposableSearchDropdown,
    ComposableSearchDropdownProps,
    IndexedObject
} from "@themuse/design-system";
import { IconCompany } from "@themuse/design-system/lib/components/Icons";
import { UseComboboxStateChange } from "downshift"; // eslint-disable-line import/no-extraneous-dependencies
import { SearchCompany } from "interfaces/context/searchContextInterfaces";
import { suggestionApiQueryMaxlength } from "utils/constants";

import homeStyles from "styles/Home.module.scss";
import styles from "./SearchInput.module.scss";

interface SearchInputFieldProps {
    clear?: boolean;
    onClear?: () => void;
}

interface CompanySearchFieldProps extends SearchInputFieldProps {
    company: SearchCompany;
    onInputChange: (changes: UseComboboxStateChange<IndexedObject>) => void;
    noResultsMessage: React.ReactNode;
}

const menuToggle = (value: boolean) => {
    const navHeader = document.querySelectorAll("header[class^='Header_header']");

    navHeader.forEach((elem) => {
        if (value) {
            elem.classList.add(homeStyles.inputMenuOpen);
        } else {
            elem.classList.remove(homeStyles.inputMenuOpen);
        }
    });
};

const CompanySearchInput = (props: CompanySearchFieldProps) => {
    const {
        company, clear, onInputChange, noResultsMessage
    } = props;
    const { companySuggestions, userSelectedCompany } = company;
    const placeHolderText = "All Companies";

    const dropdownProps: ComposableSearchDropdownProps = {
        classes: {
            container: styles.searchInputContainer,
            inputIcon: styles.inputIcon
        },
        dropdownProps: {
            IconComponent: <IconCompany />,
            dropdownList: companySuggestions,
            dropdownTitle: "Type to select a company",
            debounceWait: 200,
            labelText: "Companies",
            placeHolderText,
            inputId: "company-input",
            maxLength: suggestionApiQueryMaxlength,
            onInputChange,
            onMenuToggle: menuToggle,
            clearValue: clear,
            fieldValue: userSelectedCompany,
            showMenuOnFocus: true,
            refocusMobileOnClear: true,
            noResultsMessage
        }
    };

    return <ComposableSearchDropdown {...dropdownProps} />;
};

CompanySearchInput.displayName = "CompanySearchInput";
export default CompanySearchInput;
